module.exports = __webpack_public_path__ + "media/images/favicon_red-a9c2a17953b63284cbd1b66af4c7bc8f.ico";